type BankCardRangeType = {
  from: string;
  to: number | null;
};

type BankListType = {
  [key: string]: BankCardRangeType[];
};

export const list: BankListType = {
  halyk: [
    {
      from: '5483180000',
      to: 5483189999,
    },
    {
      from: '5243450000',
      to: 5243459999,
    },
    {
      from: '5354510000',
      to: 5354510199,
    },
    {
      from: '5175110000',
      to: 5175110634,
    },
    {
      from: '5522040000',
      to: 5522049999,
    },
    {
      from: '5498310000',
      to: 5498314249,
    },
    {
      from: '5376010000',
      to: 5376010001,
    },
    {
      from: '5376010001',
      to: 5376010002,
    },
    {
      from: '5498314290',
      to: 5498319999,
    },
    {
      from: '5468760000',
      to: 5468769999,
    },
    {
      from: '5175110635',
      to: 5175110638,
    },
    {
      from: '6762000000',
      to: 6762009999,
    },
    {
      from: '5354510200',
      to: 5354514999,
    },
    {
      from: '5498314250',
      to: 5498314289,
    },
    {
      from: '5582910000',
      to: 5582919999,
    },
    {
      from: '5483190000',
      to: 5483199999,
    },
    {
      from: '5470890000',
      to: 5470899999,
    },
    {
      from: '5101110000',
      to: 5101119999,
    },
    {
      from: '5594860000',
      to: 5594869999,
    },
    {
      from: '5175110639',
      to: 5175119999,
    },
    {
      from: '6762050000',
      to: 6762059999,
    },
    {
      from: '5101450000',
      to: 5101459999,
    },
    {
      from: '5376010002',
      to: 5376019999,
    },
    {
      from: '5480000000',
      to: 5480009999,
    },
    {
      from: '5354515000',
      to: 5354519999,
    },
    {
      from: '5578340000',
      to: 5578349999,
    },
    {
      from: '5354174300',
      to: 5354174399,
    },
    {
      from: '5372445800',
      to: 5372445899,
    },
    {
      from: '5355601200',
      to: 5355601299,
    },
    {
      from: '537601',
      to: null,
    },
    {
      from: '5154606000',
      to: 5154606099,
    },
    {
      from: '5155418200',
      to: 5155418299,
    },
    {
      from: '5180416300',
      to: 5180416399,
    },
    {
      from: '5180417700',
      to: 5180417799,
    },
    {
      from: '5444129400',
      to: 5444129499,
    },
    {
      from: '5445594200',
      to: 5445594299,
    },
    {
      from: '5447562100',
      to: 5447562199,
    },
    {
      from: '5447568800',
      to: 5447568899,
    },
    {
      from: '5454963400',
      to: 5454963499,
    },
    {
      from: '5455733600',
      to: 5455733699,
    },
    {
      from: '5459312900',
      to: 5459312999,
    },
    {
      from: '5502726600',
      to: 5502726699,
    },
    {
      from: '5530258200',
      to: 5530258299,
    },
    {
      from: '5530277500',
      to: 5530277599,
    },
    {
      from: '5595237900',
      to: 5595237999,
    },
    {
      from: '405772',
      to: null,
    },
    {
      from: '414621',
      to: null,
    },
    {
      from: '403167',
      to: null,
    },
    {
      from: '422192',
      to: null,
    },
    {
      from: '440254',
      to: null,
    },
    {
      from: '450286',
      to: null,
    },
    {
      from: '440259',
      to: null,
    },
    {
      from: '422191',
      to: null,
    },
    {
      from: '404741',
      to: null,
    },
    {
      from: '414623',
      to: null,
    },
    {
      from: '414622',
      to: null,
    },
    {
      from: '439087',
      to: null,
    },
    {
      from: '427704',
      to: null,
    },
    {
      from: '440257',
      to: null,
    },
    {
      from: '440256',
      to: null,
    },
    {
      from: '439088',
      to: null,
    },
    {
      from: '404363',
      to: null,
    },
    {
      from: '440258',
      to: null,
    },
    {
      from: '44832509',
      to: null,
    },
    {
      from: '44832550',
      to: null,
    },
    {
      from: '448326',
      to: null,
    },
    {
      from: '44832608',
      to: null,
    },
    {
      from: '448323',
      to: null,
    },
    {
      from: '448325',
      to: null,
    },
    {
      from: '485634',
      to: null,
    },
    {
      from: '448324',
      to: null,
    },
    {
      from: '44832538',
      to: null,
    },
    {
      from: '429556',
      to: null,
    },
    {
      from: '44832502',
      to: null,
    },
    {
      from: '44832560',
      to: null,
    },
    {
      from: '462781',
      to: null,
    },
    {
      from: '44832509',
      to: null,
    },
    {
      from: '44832550',
      to: null,
    },
    {
      from: '448326',
      to: null,
    },
    {
      from: '44832608',
      to: null,
    },
    {
      from: '448323',
      to: null,
    },
    {
      from: '448325',
      to: null,
    },
    {
      from: '485634',
      to: null,
    },
    {
      from: '448324',
      to: null,
    },
    {
      from: '44832538',
      to: null,
    },
    {
      from: '429556',
      to: null,
    },
    {
      from: '44832502',
      to: null,
    },
    {
      from: '44832560',
      to: null,
    },
    {
      from: '462781',
      to: null,
    },
    {
      from: '405772',
      to: null,
    },
    {
      from: '414621',
      to: null,
    },
    {
      from: '403167',
      to: null,
    },
    {
      from: '422192',
      to: null,
    },
    {
      from: '440254',
      to: null,
    },
    {
      from: '450286',
      to: null,
    },
    {
      from: '440259',
      to: null,
    },
    {
      from: '422191',
      to: null,
    },
    {
      from: '404741',
      to: null,
    },
    {
      from: '414623',
      to: null,
    },
    {
      from: '414622',
      to: null,
    },
    {
      from: '439087',
      to: null,
    },
    {
      from: '427704',
      to: null,
    },
    {
      from: '440257',
      to: null,
    },
    {
      from: '440256',
      to: null,
    },
    {
      from: '439088',
      to: null,
    },
    {
      from: '404363',
      to: null,
    },
    {
      from: '440258',
      to: null,
    },
    {
      from: '424467',
      to: null,
    },
    {
      from: '413265',
      to: null,
    },
    {
      from: '416443',
      to: null,
    },
    {
      from: '417779',
      to: null,
    },
    {
      from: '400303',
      to: null,
    },
    {
      from: '427717',
      to: null,
    },
    {
      from: '415602',
      to: null,
    },
    {
      from: '440564',
      to: null,
    },
    {
      from: '440565',
      to: null,
    },
    {
      from: '431433',
      to: null,
    },
    {
      from: '440562',
      to: null,
    },
    {
      from: '440563',
      to: null,
    },
    {
      from: '462780',
      to: null,
    },
    {
      from: '410708',
      to: null,
    },
    {
      from: '410729',
      to: null,
    },
    {
      from: '425680',
      to: null,
    },
    {
      from: '524345',
      to: null,
    },
    {
      from: '512752',
      to: null,
    },
    {
      from: '553089',
      to: null,
    },
    {
      from: '405465',
      to: null,
    },
    {
      from: '410728',
      to: null,
    },
    {
      from: '410727',
      to: null,
    },
    {
      from: '444482',
      to: null,
    },
    {
      from: '410726',
      to: null,
    },
    {
      from: '512801',
      to: null,
    },
    {
      from: '548319',
      to: null,
    },
    {
      from: '546876',
      to: null,
    },
    {
      from: '548000',
      to: null,
    },
    {
      from: '558291',
      to: null,
    },
    {
      from: '557834',
      to: null,
    },
    {
      from: '510145',
      to: null,
    },
    {
      from: '524345',
      to: null,
    },
    {
      from: '552204',
      to: null,
    },
    {
      from: '517511',
      to: null,
    },
    {
      from: '548318',
      to: null,
    },
    {
      from: '547089',
      to: null,
    },
    {
      from: '549831',
      to: null,
    },
    {
      from: '535451',
      to: null,
    },
    {
      from: '452440',
      to: null,
    },
    {
      from: '439087',
      to: null,
    },
    {
      from: '427704',
      to: null,
    },
    {
      from: '422191',
      to: null,
    },
    {
      from: '405772',
      to: null,
    },
    {
      from: '422126',
      to: null,
    },
    {
      from: '440257',
      to: null,
    },
    {
      from: '439088',
      to: null,
    },
    {
      from: '414621',
      to: null,
    },
  ],
  jusan: [
    {
      from: '5596620000',
      to: 5596629999,
    },
    {
      from: '5127690000',
      to: 5127699999,
    },
    {
      from: '5378250000',
      to: 5378259999,
    },
    {
      from: '5120954188',
      to: 5120954188,
    },
    {
      from: '5120954189',
      to: 5120959999,
    },
    {
      from: '5395450000',
      to: 5395459999,
    },
    {
      from: '5120950000',
      to: 5120954187,
    },
    {
      from: '5265720000',
      to: 5265729999,
    },
    {
      from: '5356500000',
      to: 5356509999,
    },
    {
      from: '5173310000',
      to: 5173319999,
    },
    {
      from: '5540660000',
      to: 5540669999,
    },
    {
      from: '5191700000',
      to: 5191709999,
    },
    {
      from: '5154651900',
      to: 5154651999,
    },
    {
      from: '5332641800',
      to: 5332641899,
    },
    {
      from: '5167972900',
      to: 5167972999,
    },
    {
      from: '5154958300',
      to: 5154958399,
    },
    {
      from: '5154966400',
      to: 5154966499,
    },
    {
      from: '5155122600',
      to: 5155122699,
    },
    {
      from: '5187724200',
      to: 5187724299,
    },
    {
      from: '5349677200',
      to: 5349677299,
    },
    {
      from: '5480658600',
      to: 5480658699,
    },
    {
      from: '5492887800',
      to: 5492887899,
    },
    {
      from: '5595281600',
      to: 5595281699,
    },
    {
      from: '5598604500',
      to: 5598604599,
    },
    {
      from: '441329',
      to: null,
    },
    {
      from: '441328',
      to: null,
    },
    {
      from: '441327',
      to: null,
    },
    {
      from: '463743',
      to: null,
    },
    {
      from: '413264',
      to: null,
    },
    {
      from: '413263',
      to: null,
    },
    {
      from: '413262',
      to: null,
    },
    {
      from: '458261',
      to: null,
    },
    {
      from: '413261',
      to: null,
    },
    {
      from: '484893',
      to: null,
    },
    {
      from: '458260',
      to: null,
    },
    {
      from: '512095',
      to: null,
    },
    {
      from: '426668',
      to: null,
    },
    {
      from: '431253',
      to: null,
    },
    {
      from: '553107',
      to: null,
    },
    {
      from: '417803',
      to: null,
    },
    {
      from: '433318',
      to: null,
    },
    {
      from: '433317',
      to: null,
    },
    {
      from: '431879',
      to: null,
    },
    {
      from: '427764',
      to: null,
    },
    {
      from: '405258',
      to: null,
    },
    {
      from: '512769',
      to: null,
    },
    {
      from: '405257',
      to: null,
    },
    {
      from: '405255',
      to: null,
    },
    {
      from: '405256',
      to: null,
    },
    {
      from: '479068',
      to: null,
    },
    {
      from: '423208',
      to: null,
    },
    {
      from: '433319',
      to: null,
    },
    {
      from: '537825',
      to: null,
    },
    {
      from: '512095',
      to: null,
    },
    {
      from: '519170',
      to: null,
    },
    {
      from: '526572',
      to: null,
    },
    {
      from: '535650',
      to: null,
    },
    {
      from: '539545',
      to: null,
    },
    {
      from: '458261',
      to: null,
    },
    {
      from: '413263',
      to: null,
    },
    {
      from: '441328',
      to: null,
    },
    {
      from: '458260',
      to: null,
    },
    {
      from: '413264',
      to: null,
    },
  ],
  freedom: [
    {
      from: '5269880001',
      to: 5269889999,
    },
    {
      from: '5269880000',
      to: 5269880000,
    },
    {
      from: '5504910000',
      to: 5504910000,
    },
    {
      from: '6709900000',
      to: 6709909999,
    },
    {
      from: '5396740001',
      to: 5396749999,
    },
    {
      from: '5396740000',
      to: 5396740000,
    },
    {
      from: '5377369000',
      to: 5377369099,
    },
    {
      from: '5255829800',
      to: 5255829899,
    },
    {
      from: '5504910001',
      to: 5504919999,
    },
    {
      from: '5455643200',
      to: 5455643299,
    },
    {
      from: '5432281100',
      to: 5432281199,
    },
    {
      from: '5209047900',
      to: 5209047999,
    },
    {
      from: '5262204000',
      to: 5262204099,
    },
    {
      from: '5354011400',
      to: 5354011499,
    },
    {
      from: '5327846800',
      to: 5327846899,
    },
    {
      from: '539674',
      to: null,
    },
  ],
  kaspi: [
    {
      from: '5169497100',
      to: 5169497199,
    },
    {
      from: '5167796300',
      to: 5167796399,
    },
    {
      from: '5300408600',
      to: 5300408699,
    },
    {
      from: '5315943400',
      to: 5315943499,
    },
    {
      from: '5354137000',
      to: 5354137099,
    },
    {
      from: '5169493100',
      to: 5169493199,
    },
    {
      from: '5370400000',
      to: 5370400099,
    },
    {
      from: '5169490000',
      to: 5169490099,
    },
    {
      from: '417661',
      to: null,
    },
    {
      from: '417663',
      to: null,
    },
    {
      from: '417660',
      to: null,
    },
    {
      from: '417662',
      to: null,
    },
    {
      from: '417664',
      to: null,
    },
    {
      from: '440043',
      to: null,
    },
    {
      from: '417660',
      to: null,
    },
    {
      from: '417662',
      to: null,
    },
    {
      from: '486390',
      to: null,
    },
    {
      from: '516949',
      to: null,
    },
    {
      from: '537040',
      to: null,
    },
  ],
  nur: [
    {
      from: '5470439900',
      to: 5470439999,
    },
    {
      from: '5180852900',
      to: 5180852999,
    },
    {
      from: '6773240000',
      to: 6773249999,
    },
    {
      from: '5487630000',
      to: 5487639999,
    },
    {
      from: '5534810000',
      to: 5534819999,
    },
    {
      from: '5398940000',
      to: 5398949999,
    },
    {
      from: '402135',
      to: null,
    },
    {
      from: '539894',
      to: null,
    },
    {
      from: '440127',
      to: null,
    },
    {
      from: '409872',
      to: null,
    },
    {
      from: '440128',
      to: null,
    },
    {
      from: '425889',
      to: null,
    },
    {
      from: '548763',
      to: null,
    },
    {
      from: '440126',
      to: null,
    },
    {
      from: '553481',
      to: null,
    },
    {
      from: '440125',
      to: null,
    },
    {
      from: '440126',
      to: null,
    },
    {
      from: '402135',
      to: null,
    },
  ],
  ziraat: [
    {
      from: '5167780000',
      to: 5167780049,
    },
    {
      from: '5354570000',
      to: 5354570099,
    },
    {
      from: '5167780050',
      to: 5167780099,
    },
    {
      from: '516778',
      to: null,
    },
  ],
  bck: [
    {
      from: '5252440000',
      to: 5252449999,
    },
    {
      from: '5596720000',
      to: 5596729999,
    },
    {
      from: '5204180000',
      to: 5204189999,
    },
    {
      from: '5355810000',
      to: 5355819999,
    },
    {
      from: '5104450000',
      to: 5104454999,
    },
    {
      from: '5488280000',
      to: 5488289999,
    },
    {
      from: '6776790000',
      to: 6776799999,
    },
    {
      from: '5104455000',
      to: 5104459999,
    },
    {
      from: '5155524700',
      to: 5155524799,
    },
    {
      from: '5180220100',
      to: 5180220199,
    },
    {
      from: '5446247100',
      to: 5446247199,
    },
    {
      from: '5446904000',
      to: 5446904099,
    },
    {
      from: '5447720000',
      to: 5447729999,
    },
    {
      from: '5104450000',
      to: 5104454999,
    },
    {
      from: '5374217900',
      to: 5374217999,
    },
    {
      from: '5471857200',
      to: 5471857299,
    },
    {
      from: '5487860000',
      to: 5487860099,
    },
    {
      from: '5598603700',
      to: 5598603799,
    },
    {
      from: '446375',
      to: null,
    },
    {
      from: '428790',
      to: null,
    },
    {
      from: '489992',
      to: null,
    },
    {
      from: '466720',
      to: null,
    },
    {
      from: '489993',
      to: null,
    },
    {
      from: '489988',
      to: null,
    },
    {
      from: '525244',
      to: null,
    },
    {
      from: '548828',
      to: null,
    },
    {
      from: '510445',
      to: null,
    },
    {
      from: '544772',
      to: null,
    },
    {
      from: '520418',
      to: null,
    },
  ],
  bereke: [
    {
      from: '5301800000',
      to: 5301809999,
    },
    {
      from: '5478440003',
      to: 5478440003,
    },
    {
      from: '5355410000',
      to: 5355419999,
    },
    {
      from: '5398133600',
      to: 5398133699,
    },
    {
      from: '5478440004',
      to: 5478440005,
    },
    {
      from: '5156270000',
      to: 5156279999,
    },
    {
      from: '5478440000',
      to: 5478440003,
    },
    {
      from: '5398136900',
      to: 5398136999,
    },
    {
      from: '5437832000',
      to: 5437832099,
    },
    {
      from: '5391440000',
      to: 5391449999,
    },
    {
      from: '5478440006',
      to: 5478440006,
    },
    {
      from: '5429997300',
      to: 5429997399,
    },
    {
      from: '5392150000',
      to: 5392159999,
    },
    {
      from: '5324240000',
      to: 5324249999,
    },
    {
      from: '5478440007',
      to: 5478449999,
    },
    {
      from: '5437832400',
      to: 5437832499,
    },
    {
      from: '5398135100',
      to: 5398135199,
    },
    {
      from: '5427620000',
      to: 5427629999,
    },
    {
      from: '5372497000',
      to: 5372497099,
    },
    {
      from: '5595241200',
      to: 5595241299,
    },
    {
      from: '5454344500',
      to: 5454344599,
    },
    {
      from: '5492893200',
      to: 5492893299,
    },
    {
      from: '5155048200',
      to: 5155048299,
    },
    {
      from: '5155479800',
      to: 5155479899,
    },
    {
      from: '5167791300',
      to: 5167791399,
    },
    {
      from: '5180859700',
      to: 5180859799,
    },
    {
      from: '5530279300',
      to: 5530279399,
    },
    {
      from: '539144',
      to: null,
    },
    {
      from: '547844',
      to: null,
    },
    {
      from: '539215',
      to: null,
    },
    {
      from: '530180',
      to: null,
    },
    {
      from: '542762',
      to: null,
    },
    {
      from: '535541',
      to: null,
    },
  ],
  eurasian: [
    {
      from: '5298180011',
      to: 5298180011,
    },
    {
      from: '5269940008',
      to: 5269940008,
    },
    {
      from: '5269940010',
      to: 5269940010,
    },
    {
      from: '5298180009',
      to: 5298180009,
    },
    {
      from: '5269940009',
      to: 5269940009,
    },
    {
      from: '5298180004',
      to: 5298180004,
    },
    {
      from: '5298180010',
      to: 5298180010,
    },
    {
      from: '5556760000',
      to: 5556769999,
    },
    {
      from: '5269940007',
      to: 5269940007,
    },
    {
      from: '5126660000',
      to: 5126660099,
    },
    {
      from: '5298180012',
      to: 5298180012,
    },
    {
      from: '5269940015',
      to: 5269949999,
    },
    {
      from: '5298180005',
      to: 5298180005,
    },
    {
      from: '5269940014',
      to: 5269940014,
    },
    {
      from: '5269940013',
      to: 5269940013,
    },
    {
      from: '5269940000',
      to: 5269940003,
    },
    {
      from: '5298180006',
      to: 5298180006,
    },
    {
      from: '5298180014',
      to: 5298180014,
    },
    {
      from: '5269940005',
      to: 5269940005,
    },
    {
      from: '5298180013',
      to: 5298180013,
    },
    {
      from: '5269940006',
      to: 5269940006,
    },
    {
      from: '5298180000',
      to: 5298180003,
    },
    {
      from: '5437740000',
      to: 5437749999,
    },
    {
      from: '5304960000',
      to: 5304969999,
    },
    {
      from: '5298180007',
      to: 5298180007,
    },
    {
      from: '5336420000',
      to: 5336429999,
    },
    {
      from: '5269940012',
      to: 5269940012,
    },
    {
      from: '5217000000',
      to: 5217009999,
    },
    {
      from: '5298180015',
      to: 5298189999,
    },
    {
      from: '5269940004',
      to: 5269940004,
    },
    {
      from: '5269940011',
      to: 5269940011,
    },
    {
      from: '5298180008',
      to: 5298180008,
    },
    {
      from: '5274827700',
      to: 5274827799,
    },
    {
      from: '5471865000',
      to: 5471865099,
    },
    {
      from: '5464069700',
      to: 5464069799,
    },
    {
      from: '5459607900',
      to: 5459607999,
    },
    {
      from: '5154991100',
      to: 5154991199,
    },
    {
      from: '5155122100',
      to: 5155122199,
    },
    {
      from: '5155450200',
      to: 5155450299,
    },
    {
      from: '5180270300',
      to: 5180270399,
    },
    {
      from: '5180278700',
      to: 5180278799,
    },
    {
      from: '5180535600',
      to: 5180535699,
    },
    {
      from: '5185128800',
      to: 5185128899,
    },
    {
      from: '5209282000',
      to: 5209282099,
    },
    {
      from: '5209543400',
      to: 5209543499,
    },
    {
      from: '5214087200',
      to: 5214087299,
    },
    {
      from: '5214327400',
      to: 5214327499,
    },
    {
      from: '5214374100',
      to: 5214374199,
    },
    {
      from: '5431877500',
      to: 5431877599,
    },
    {
      from: '5432284700',
      to: 5432284799,
    },
    {
      from: '5433945500',
      to: 5433945599,
    },
    {
      from: '5443532300',
      to: 5443532399,
    },
    {
      from: '5445354000',
      to: 5445354099,
    },
    {
      from: '5446305800',
      to: 5446305899,
    },
    {
      from: '5446984000',
      to: 5446984099,
    },
    {
      from: '5455958500',
      to: 5455958599,
    },
    {
      from: '5470372500',
      to: 5470372599,
    },
    {
      from: '5471874600',
      to: 5471874699,
    },
    {
      from: '5471887000',
      to: 5471887099,
    },
    {
      from: '5487863700',
      to: 5487863799,
    },
    {
      from: '5490761600',
      to: 5490761699,
    },
    {
      from: '5492899500',
      to: 5492899599,
    },
    {
      from: '5595248800',
      to: 5595248899,
    },
    {
      from: '5595292200',
      to: 5595292299,
    },
    {
      from: '5599275100',
      to: 5599275199,
    },
    {
      from: '429440',
      to: null,
    },
    {
      from: '409663',
      to: null,
    },
    {
      from: '429439',
      to: null,
    },
    {
      from: '412464',
      to: null,
    },
    {
      from: '429438',
      to: null,
    },
    {
      from: '403259',
      to: null,
    },
    {
      from: '405709',
      to: null,
    },
  ],
  forte: [
    {
      from: '5257520000',
      to: 5257529999,
    },
    {
      from: '5477520000',
      to: 5477520009,
    },
    {
      from: '5477520020',
      to: 5477520049,
    },
    {
      from: '5243540000',
      to: 5243549999,
    },
    {
      from: '5177920000',
      to: 5177929999,
    },
    {
      from: '5366850000',
      to: 5366859999,
    },
    {
      from: '5132230000',
      to: 5132239999,
    },
    {
      from: '5477520050',
      to: 5477529999,
    },
    {
      from: '5477520010',
      to: 5477520019,
    },
    {
      from: '5553350000',
      to: 5553359999,
    },
    {
      from: '5388358300',
      to: 5388358399,
    },
    {
      from: '5446902500',
      to: 5446902599,
    },
    {
      from: '5329815100',
      to: 5329815199,
    },
    {
      from: '5163638700',
      to: 5163638799,
    },
    {
      from: '5214404000',
      to: 5214404099,
    },
    {
      from: '5317694200',
      to: 5317694299,
    },
    {
      from: '5459742400',
      to: 5459742499,
    },
    {
      from: '5470574100',
      to: 5470574199,
    },
    {
      from: '5545366700',
      to: 5545366799,
    },
    {
      from: '5595276900',
      to: 5595276999,
    },
    {
      from: '400289',
      to: null,
    },
    {
      from: '427274',
      to: null,
    },
    {
      from: '404245',
      to: null,
    },
    {
      from: '404243',
      to: null,
    },
    {
      from: '404242',
      to: null,
    },
    {
      from: '524354',
      to: null,
    },
    {
      from: '547752',
      to: null,
    },
    {
      from: '517792',
      to: null,
    },
    {
      from: '513223',
      to: null,
    },
    {
      from: '525752',
      to: null,
    },
    {
      from: '536685',
      to: null,
    },
  ],
  homecredit: [
    {
      from: '404932',
      to: null,
    },
    {
      from: '489199',
      to: null,
    },
  ],
};
